import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { SidePanel } from '@hivewatch/dark'

export interface DarkTourPlansSidePanelIProps {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  isExpanded: boolean
  onToggleExpansion: () => void
  isBodyPadded?: boolean
  dataTestid?: string
}

/**
 * Rail container shared by every Tour Plans view. Each view renders its own
 * container — the same shape the incident drawer uses, where TraceLogDrawer and
 * WorkflowDrawer each render IncidentDrawerContainer — so a view owns its
 * header/footer slots without lifting form state to the panel.
 */
export const DarkTourPlansSidePanel = ({
  children,
  header,
  footer,
  isExpanded,
  onToggleExpansion,
  isBodyPadded = true,
  dataTestid = 'TourPlansPanel',
}: DarkTourPlansSidePanelIProps) => {
  const colorScheme = useLightMode()
  const { t } = useTranslation()

  return (
    <SidePanel
      collapseLabel={t('floors:plan_panel_collapse_aria')}
      colorScheme={colorScheme}
      data-testid={dataTestid}
      expandLabel={t('floors:plan_panel_expand_aria')}
      footer={footer}
      header={header}
      isBodyPadded={isBodyPadded}
      isExpanded={isExpanded}
      onToggle={onToggleExpansion}
      size='sm'
    >
      {children}
    </SidePanel>
  )
}
